/**
 * Template snippet
 * 
 * @author Mautilus s.r.o.
 * @class Snippet_Template
 * @extends Snippet
 */

Snippet_Template = (function(Snippet) {

	var Snippet_Template = function() {
		this.construct.apply(this, arguments);
	};

	$.extend(true, Snippet_Template.prototype, Snippet.prototype, {
		/**
		 * @inheritdoc Snippet#init
		 */
		init: function(parent, config){
			this.$lastFocused = null;
		},
		
		/**
		 * @inheritdoc Snippet#create
		 */
		create: function() {
			if(this.config.$el) {
				return this.config.$el;
			} else {
				return this.parent.$el.find(this.config.selector || "#snippet-template");
			}
		},
		
		/**
		 * @inheritdoc Snippet#render
		 */
		render: function() {
			this.clear();
			
			// make HTML template
			var html = this.getTemplate({});
			
			// append HTML to DOM
			this.$el.html(html);
		},
		
		/**
		 * To get HTML template
		 */
		getTemplate: function(data) {
			var html = '';
			
			return html;
		},

		/**
		 * @inheritdoc Snippet#onClick
		 */
		onClick: function($el, event) {
			if(this.trigger('click', $el, event) === false) {
				return false;
			}
			return this.onEnter.apply(this, arguments);
		},
		/**
		 * @inheritdoc Snippet#onEnter
		 */
		onEnter: function($el, event) {
			var id = $el.attr('data-id');
			
			switch(id) {
				case 'xxx': this.doXXX(); break;
				case 'yyy': this.doYYY(); break;
			}
			
			return false;
		},
		/**
		 * @inheritdoc Snippet#navigate
		 */
		navigate: function(direction) {
			if (direction == "up")         { this.trigger("focus:out", this, direction); }
			else if (direction == "down")  { this.trigger("focus:out", this, direction); }
			else if (direction == "left")  { Focus.to(this.getCircleFocusable(-1)); }
			else if (direction == "right") { Focus.to(this.getCircleFocusable(+1)); }
			return false;
		},
		
		/**
		 * @inheritdoc Snippet#focus
		 */
		focus: function($el) {
			if(!$el) {
				$el = this.getFocusable(0);
			}
			return Focus.to($el);
		},
		
		/**
		 * @inheritdoc Snippet#focus
		 */
		onFocus: function($el) {
			this.$lastFocused = $el;
		},
		
		clear: function() {
			this.$el.empty();
			this.$lastFocused = null;
		},
		
		/**
		 * Cascade focus. Manage the process of Focus delegation between snippets inside Snippet
		 * 
		 * @param {Object} Snippet or jQuery
		 * @param {String} direction of Focus delegation ("up", "down", "left", "right")
		 */
		onFocusOut: function (snippet, direction) {
		}

	});

	return Snippet_Template;

})(Snippet);


//////////////////
// WEBPACK FOOTER
// ./js/snippet/_template.js
// module id = 58
// module chunks = 0